import { Helmet } from 'react-helmet'
import { APP } from '@/common/strings'
import { ONBOARDING_COPY } from '@/locales/en'
import { useCurrentAccount } from '@/account/useCurrentAccount'
import { Onboarding } from '@/onboarding/layout/OnboardingPageTemplate'

export function AccountCreated() {
    const account = useCurrentAccount()
    const hasAdviser = Boolean(account?.adviserId)
    const copy = hasAdviser
        ? ONBOARDING_COPY.accountCreated.adviserMessage
        : ONBOARDING_COPY.accountCreated.nonAdviserMessage

    return (
        <>
            <Helmet>
                <title>
                    {ONBOARDING_COPY.accountCreated.pageTitle} | {APP.title}
                </title>
            </Helmet>
            <Onboarding title={ONBOARDING_COPY.accountCreated.title} progress={100} hideActions={true}>
                <div className="flex flex-col items-center justify-center gap-6">
                    <p className="text-center font-normal text-base text-content-primary">{copy}</p>
                    <p className="text-center font-normal text-base text-content-secondary pb-4">
                        {ONBOARDING_COPY.accountCreated.secondaryMessage}
                    </p>
                </div>
            </Onboarding>
        </>
    )
}
